module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_newell_sm-f39e346956ea7107e2801fad4be28e95.png";